export const timelineCode = {
  client: "client",
  product: "product",
  sales: "sales",
  credit_note: "credit_note",
  conduce: "conduce",
  quote: "quote",
};
